import { createTheme, defaultVariantColorsResolver } from '@mantine/core';
import { brand, cruisePalette } from '../tokens/brand';

// The CSS role tokens are shared across app shells and controls. Mantine
// requires literal values for its color scale so it can calculate variants.
const control = { size: 'sm', radius: 'sm' };
export const appTheme = createTheme({
  primaryColor: 'cruise', primaryShade: 5, defaultRadius: 'sm',
  black: brand.navy,
  variantColorResolver: (input) => {
    const resolved = defaultVariantColorsResolver(input);
    const color = input.color || input.theme.primaryColor;
    if (!['cruise', 'teal'].includes(color)) return resolved;
    if (input.variant === 'filled') return { ...resolved,
      background: 'var(--cos-action)', hover: 'var(--cos-action-hover)', color: 'var(--cos-on-action)' };
    if (['outline', 'light', 'subtle', 'transparent', 'white'].includes(input.variant)) {
      return { ...resolved, color: 'var(--cos-action-text)' };
    }
    return resolved;
  },
  fontFamily: 'var(--cos-font)',
  fontSizes: { xs: '12px', sm: '13px', md: '14px', lg: '16px', xl: '18px' },
  radius: { xs: '4px', sm: '8px', md: '12px', lg: '16px', xl: '24px' },
  spacing: { xs: '8px', sm: '12px', md: '16px', lg: '24px', xl: '32px' },
  shadows: { xs: 'var(--cos-shadow-card)', sm: 'var(--cos-shadow-card)', md: 'var(--cos-shadow-dialog)' },
  headings: { fontFamily: 'var(--cos-font)', fontWeight: '700', sizes: {
    h3: { fontSize: '18px', lineHeight: '1.3' },
    h4: { fontSize: '16px', lineHeight: '1.4' },
  } },
  colors: { cruise: cruisePalette, teal: cruisePalette },
  components: {
    Button: { defaultProps: control, classNames: { root: 'cos-mantine-button' } },
    ActionIcon: {
      defaultProps: { size: 36, radius: 'md', variant: 'default' },
      classNames: { root: 'cos-mantine-icon-action' },
    },
    Text: { defaultProps: { size: 'md' } },
    Card: {
      defaultProps: { withBorder: true, radius: 'md', shadow: 'xs', padding: 'md' },
      styles: { root: { borderColor: 'var(--cos-border)', background: 'var(--cos-surface)' } },
    },
    Paper: { defaultProps: { radius: 'md' } },
    Group: { defaultProps: { gap: 'xs' } },
    Stack: { defaultProps: { gap: 'md' } },
    Input: {
      styles: { input: { fontSize: '14px' } },
    },
    InputWrapper: { styles: { label: { fontSize: '13px', fontWeight: 600 } } },
    TextInput: { defaultProps: control },
    Textarea: { defaultProps: control },
    NumberInput: { defaultProps: control },
    PasswordInput: { defaultProps: control },
    Checkbox: { defaultProps: { autoContrast: true } },
    Radio: { defaultProps: { autoContrast: true } },
    Switch: { styles: { thumb: { background: 'var(--cos-navy)' } } },
    Anchor: { styles: { root: { color: 'var(--cos-action-text)', textDecoration: 'underline' } } },
    Select: { defaultProps: control },
    MultiSelect: { defaultProps: control },
    TagsInput: { defaultProps: control },
    Modal: { defaultProps: { radius: 'lg', shadow: 'md' } },
  },
});
